<script>
	import { validateEmail, validateField } from '$lib/fieldValidation.js';

	let email;
	let firstName;
	let lastName;
	let subscribed = false;
	let errorMessage = false;
	async function sendSubscription() {
		// Checking fields
		if (!email || !firstName || !lastName || validateField(firstName) || validateField(lastName)) {
			errorMessage = 'All fields are required!';
			return false;
		} else if (validateEmail(email)) {
			errorMessage = 'Email is not valid!';
			return false;
		}

		let url = import.meta.env.VITE_SALESFORCE_SUB;
		fetch(url, {
			method: 'POST',
			mode: 'no-cors',
			body: JSON.stringify({
				email: email,
				Subscriber_First_Name__c: firstName,
				Subscriber_Last_Name__c: lastName
			})
		});
		email = '';
		subscribed = true;
	}
</script>

<div class="holder">
	<div class="top">
		<img src="/mailbox.svg" alt="" />
		<div class="content">
			<h2>Become a sustainability and real estate expert.</h2>
			<p>
				Our very best articles and properties in your inbox, every first Wednesday of the month.
			</p>
		</div>
	</div>
	<div class="bottom">
		{#if !subscribed}
			<div class="names">
				<div>
					<label for="first_name">
						<input
							type="text"
							id="first_name"
							bind:value={firstName}
							on:click={() => (errorMessage = false)}
						/>
						<span>First Name</span>
					</label>
				</div>
				<div>
					<label for="lastName">
						<input
							type="lastName"
							id="lastName"
							bind:value={lastName}
							on:click={() => (errorMessage = false)}
						/>
						<span>Last Name</span>
					</label>
				</div>
			</div>
			<div class="email-field">
				<label for="email">
					<input
						type="email"
						id="email"
						bind:value={email}
						on:click={() => (errorMessage = false)}
					/>
					<button on:click={sendSubscription}>Subscribe</button>
					<span>Email</span>
				</label>
			</div>

			{#if errorMessage}
				<p id="errorMessage">{errorMessage}</p>
			{/if}
		{:else}
			<p>Thank you for subscribing!</p>
		{/if}
	</div>
</div>

<style>
	.bottom {
		display: flex;
		padding: 0 24px 21px 31px;
		flex-direction: column;
		row-gap: 1rem;
	}

	#errorMessage {
		color: rgb(240, 74, 74);
		margin: 0;
		font-weight: bold;
		font-size: 0.9rem;
	}

	.names {
		display: flex;
		column-gap: 0.7rem;
	}

	.names div {
		width: 100%;
	}

	.email-field {
		position: relative;
		width: 100%;
	}

	.email-field button {
		position: absolute;

		right: 23px;
		top: -10px;
		bottom: 3px;
		margin: 0;
		z-index: 2;

		color: #fff;
		font-weight: 600;
		font-size: 1rem;
		cursor: pointer;
		transition: 0.2s ease;

		height: 38px;
		width: 130px;

		background: #94c852;
		border: 3px solid #d9f0bc;
		border-radius: 35px;
	}

	.bottom p {
		color: var(--primary-accent);
		font-weight: bold;
	}

	input[type='email'] {
		height: 45px;
		margin-right: 20px;
	}

	.holder {
		border: 2px solid #667779;
		border-radius: 20px;
		/* height: 228px; */
		display: block;
	}
	.content h2 {
		margin: 0;
		font-weight: 700;
		font-size: 20px;
		white-space: nowrap;
	}

	.content p {
		margin: 0;
		width: 470px;
		height: 36px;
	}

	.top {
		display: flex;
		margin: 30px 24px;
		width: 470px;
	}
	.top img {
		width: 84px;
		height: 84px;
		margin-right: 15px;
	}

	label {
		width: 100%;
		height: 40px;
		position: relative;
	}

	input {
		all: unset;
		padding: 0.75rem 1.5rem;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* 		border: 1px solid #62626450; */
		border: 1px solid #32323490;

		border-radius: 20px;
		font-size: 1rem;
		color: #626264;
		background-color: white;
		transition: 0.3s ease;
		cursor: text;
	}

	input:focus {
		border: 1px solid #32323490;
	}

	label:focus-within span {
		color: #32323490;
	}

	span {
		position: absolute;
		top: -20px;
		left: 20px;
		background-color: white;
		padding: 0 0.2rem;
		font-size: 0.85rem;
		color: #565656;
		transition: 0.3s ease;
	}

	@media only screen and (max-width: 1200px) {
		.holder {
			width: 100%;
		}
	}

	@media only screen and (max-width: 870px) {
		.holder {
			width: 100%;
		}
	}

	@media only screen and (max-width: 592px) {
		.top {
			width: 90%;
		}

		.content p,
		.top img {
			height: unset;
			width: unset;
		}

		input[type='email'] {
			width: unset;
		}

		.bottom button {
			margin: auto;
		}

		.top {
			margin: 1rem;
		}
	}

	@media only screen and (max-width: 474px) {
		.content h2 {
			font-size: 18px;
		}

		.bottom {
			flex-direction: column;
			align-content: center;
			row-gap: 10px;
			margin-bottom: 10px;
		}

		.top img {
			height: 50px;
			width: 50px;
		}

		.bottom div {
			margin: auto;
		}

		.holder {
			height: 100%;
		}
	}

	@media only screen and (max-width: 810px) {
		.top {
			margin: 30px 24px 20px 24px;
		}
	}

	@media only screen and (max-width: 690px) {
		.content h2 {
			white-space: unset;
		}
		.content p {
			width: unset;
		}
	}

	@media only screen and (max-width: 626px) {
		.content h2 {
			white-space: unset;
		}


		input[type='email'] {
			width: 380px;
		}
	}

	@media only screen and (max-width: 648px) {
		input[type='email'] {
			width: 100%;
		}
	}

	@media only screen and (max-width: 600px) {
		.top {
			margin: 30px 24px 28px 24px;
			width: 90%;
		}

		.names {
			flex-direction: column;
			row-gap: 1rem;
		}
	}

	@media only screen and (max-width: 574px) {
		.bottom button {
			margin: unset !important;
		}
	}

	@media only screen and (max-width: 566px) {
		.content p {
			width: 98%;
		}

		input[type='email'] {
			width: 300px;
		}
	}

	@media only screen and (max-width: 545px) {
		.top img {
			width: 35px;
			height: 35px;
		}

		.content h2 {
			font-size: 18px;
		}
	}

	@media only screen and (max-width: 538px) {
		.bottom {
			flex-direction: column;
			margin-left: 40px;
			align-items: center;
		}

		.holder {
			height: 100%;
			/* height: 250px; */
		}

		.bottom button {
			margin: 10px auto;
		}
	}

	@media only screen and (max-width: 510px) {
		.bottom {
			margin-left: unset;
		}

		input[type="email"] {
			width: unset;
		}

		.names, .email-field input {
			width: 100%;
		}

	}

	@media only screen and (max-width: 428px) {
		.bottom {
			margin-left: unset;
		}
		.holder {
			height: unset;
		}
	}

	@media only screen and (max-width: 384px) {
		.bottom {
			margin-left: 10px;
		}

		.holder {
			height: unset;
		}
	}
</style>
